import React, {FC} from 'react'

import cn from 'classnames/bind'

import {Col, Container, Row} from 'components/elements/grid'
import {Invoice} from 'src/types/__sanitySchema__'

import s from './InvoiceWhy.module.scss'
import LandingsTitle from '../../LandingsTitle/LandingsTitle'
const cx = cn.bind(s)

interface IInvoiceWhyProps {
	className?: string
	content: Invoice['why']
}

/** InvoiceWhy block component */
const InvoiceWhy: FC<IInvoiceWhyProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} subtitle={content?.subtitle} />
				<Row>
					<Col xl={{span: 10, offset: 1}}>
						<ul className={s.list}>
							{content?.items?.map((item) => (
								<li key={item._key || item.title} className={s.item}>
									<h3 className={cx('itemTitle', 'h3')}>{item.title}</h3>
									<p className={s.itemDescription}>{item.description}</p>
								</li>
							))}
						</ul>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

InvoiceWhy.displayName = 'InvoiceWhy'

export default InvoiceWhy
